import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MasterRouteModule } from "./master-route/master-route.module";
import { MasterOperationService } from "./services/master-operation.service";
import { ClinicMasterService } from "./services/clinic-master.service";
import { OrganizationMasterService } from "./services/organization-master.service";
import { ServiceMasterService } from "./services/service-master.service";
import { TimeslotMasterService } from "./services/timeslot-master.service";
import { RoleMasterService } from "./services/role-master.service";
import { SpecializeMasterService } from "./services/specialize-master.service";
import { NoteService } from "./services/note.service";
import { TagMasterService } from "./services/tag-master.service";
import { ProcedureService } from "./services/procedure.service";
import { PromotionCodeService } from "./services/promotion-code.service";
import { DrugServiceService } from "./services/drug-service.service";
import { DropdownModule } from "ngx-dropdown";
import { SubscriptionService } from "./services/subscription.service";
import { SystemInfoComponent } from "./system-info/system-info.component";

@NgModule({
  imports: [CommonModule, MasterRouteModule],
  declarations: [],
  providers: [
    MasterOperationService,
    ProcedureService,
    SpecializeMasterService,
    ClinicMasterService,
    OrganizationMasterService,
    ServiceMasterService,
    TimeslotMasterService,
    RoleMasterService,
    DrugServiceService,
    TagMasterService,
    PromotionCodeService,
    SubscriptionService,
    NoteService
  ]
})
export class MasterModule {}



// WEBPACK FOOTER //
// ./src/app/section/master/master.module.ts